import { render, staticRenderFns } from "./BrickSettingsJourney.vue?vue&type=template&id=15b721a1&scoped=true&"
import script from "./BrickSettingsJourney.vue?vue&type=script&lang=js&"
export * from "./BrickSettingsJourney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b721a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b721a1')) {
      api.createRecord('15b721a1', component.options)
    } else {
      api.reload('15b721a1', component.options)
    }
    module.hot.accept("./BrickSettingsJourney.vue?vue&type=template&id=15b721a1&scoped=true&", function () {
      api.rerender('15b721a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/BrickSettings/Journey/BrickSettingsJourney.vue"
export default component.exports